import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const WallboxAlfen: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m600 660h-420v-540h345c41.35 0 75 33.65 75 75zm-390-30h360v-435c0-24.81-20.19-45-45-45h-315z' />
    <path d='m310.36 599.28c-38.4 0-69.64-31.24-69.64-69.64s31.24-69.64 69.64-69.64 69.64 31.24 69.64 69.64-31.24 69.64-69.64 69.64zm0-109.28c-21.86 0-39.64 17.78-39.64 39.64s17.78 39.64 39.64 39.64 39.64-17.78 39.64-39.64-17.78-39.64-39.64-39.64z' />
    <path d='m469.64 599.28c-38.4 0-69.64-31.24-69.64-69.64s31.24-69.64 69.64-69.64 69.64 31.24 69.64 69.64-31.24 69.64-69.64 69.64zm0-109.28c-21.86 0-39.64 17.78-39.64 39.64s17.78 39.64 39.64 39.64 39.64-17.78 39.64-39.64-17.78-39.64-39.64-39.64z' />
    <path d='m510 360h-240v-150h185c30.33 0 55 24.67 55 55zm-210-30h180v-65c0-13.79-11.21-25-25-25h-155z' />
  </IconBase>
));

WallboxAlfen.displayName = 'WallboxAlfen';

export default WallboxAlfen;
